import {useEffect} from 'react';
import {getCountry, getLocale} from './dazn/Region';

let isChatBotEnabled: boolean;
let chatBotId: string;
let chatBotHost: string;

const checkIfChatBotEnabled = () => {
    if (isChatBotEnabled !== undefined) {
        return isChatBotEnabled;
    }

    try {
        isChatBotEnabled = window.dazn.features.getVariableBooleanAnonymous(
            'f_ar_yellow_chatbot',
            'isEnabledInLP'
        );

        return isChatBotEnabled;
    } catch (_err) {
        return false;
    }
};

const getChatBotId = () => {
    if (chatBotId !== undefined) {
        return chatBotId;
    }

    try {
        chatBotId = window.dazn.features.getVariableStringAnonymous(
            'f_ar_yellow_chatbot',
            'botId'
        );

        return chatBotId;
    } catch (_err) {
        return '';
    }
};

const getChatBotHost = () => {
    if (chatBotHost !== undefined) {
        return chatBotHost;
    }

    try {
        chatBotHost = window.dazn.features.getVariableStringAnonymous(
            'f_ar_yellow_chatbot',
            'host'
        );
        return chatBotHost;
    } catch (_err) {
        return '';
    }
};

const loadYellowMessengerScript = (
    botId: string,
    host: string,
    locale: string,
    region: string
) => {
    const scriptId = 'yellow_ai_chatbot';

    // Check if the script is already present
    if (document.getElementById(scriptId)) {
        (window as any).YellowMessengerPlugin?.show();
        return;
    }

    // Create the script content dynamically
    const scriptCode = `
        window.ymConfig = {
            "bot": "${botId}",
            "host": "${host}",
            "payload": {
                "current_locale": "${locale}",
                "current_region": "${region}"
            }
        };
        (function() {
            var w = window,
                ic = w.YellowMessenger;
            if ("function" === typeof ic) ic("reattach_activator"), ic("update", ymConfig);
            else {
                var d = document,
                    i = function() {
                        i.c(arguments)
                    };
    
                function l() {
                    var e = d.createElement("script");
                    e.type = "text/javascript", e.async = !0, e.src = "https://cdn.yellowmessenger.com/plugin/widget-v2/latest/dist/main.min.js";
                    var t = d.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(e, t);
                    e.onload = function () {
                        ${detectBrowser()};
                    };
                }
                i.q = [], i.c = function(e) {
                    i.q.push(e)
                }, w.YellowMessenger = i, w.attachEvent ? w.attachEvent('onload', l) : w.addEventListener('load', l, !1),l();
            }
        })();
    `;

    // Create the script tag and append it to the document body
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('id', scriptId);
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.innerHTML = scriptCode;
    document.body.appendChild(scriptTag);
};

// Helper to inject custom styles into the iframe
const addCustomStylesToIframe = (iframeId: string) => {
    const cssStyles = `
        #chatContainer {
              background: black !important;
            }
            #chatDetails {
              background: #0C161C !important;
              border-bottom: 1px solid #3d4549;
            }
            #chatDetails .close-button img {
              padding: 0px !important; 
              color: #DDDEDF !important;
            }
            #chat-title{
              color: #A464FF !important;
            }
            #chatBoxMainContainer .timestamp-bot,
            #chatBoxMainContainer .timestamp-user {
              color: #9ea2a4 !important;
            }
            #chatBoxMainContainer .date-button {
              background: #242d33 !important;
            }
            #chatBoxMainContainer .from-me div {
              background: #242d33 !important;
            }
            #chatBoxMainContainer .from-them div {
              background: #080E12 !important;
            }
            #chatOptions .option.inlineQR {
              padding-block: 4.5px;
              padding-inline: 10px;
            }
            #chatOptions .option img {
              width: 20px !important;
              height: 20px !important;
              margin: 0px !important;
              padding: 0px !important;
            }
            #chatBoxMainContainer button.option:hover {
              text-shadow: none !important;
            }
            .send-input {
              background: #080E12 !important;
            }
            .send-input .attachment-button i {
              color: #3d4549;
              opacity: 1 !important;
            }
            .send-input .send-button {
              color: #9359e4 !important;
            }
            .send-input-form {
              background: black !important;
              border-top: 1px solid #3d4549 !important;
            }
            .send-input-form .new-home-button {
              color: #3d4549 !important;
            }
            .chat-form {
              background: #0C161C !important;
            }
            #ymMsgInput {
              background: #0C161C !important;
            }
            .markdown-ul.ul {
              list-style-type: disc;
            }
            .cards .slick-slide {
              background: #080E12 !important;
              border: 1px solid #9359E4 !important;
            }
            .card .card-content {
              background: #080E12 !important;
            }
            .card .card_title {
              color: #F9FAFA !important;
            }
            .card .card_description {
              color: #F9FAFA !important;
            }
            .card_description a {
              color: #007AFF !important;
              font-weight: 700;
            }
            .card_description a:hover {
              color: #268DFD !important;
              text-decoration: none;
            }
            .slick-prev, .slick-next {
              background: #9359E4 !important;
              border: 1px solid #9359E4 !important;
            }
            .card_buttons ul {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }
            .card_buttons li {
              display: flex !important;
            }
            .card button {
              background: #FFFFFF !important;
              color: #0C161C !important;
              text-align: center !important;
              margin: 0 16px;
              font-weightP: 700;
              border-radius: 6px
            }
            .card_buttons ul:last-child li:last-child button {
              margin-bottom: 8px !important;
            }
            .card button:hover {
              background: #DDDEDF !important;
            }
            .cards .slick-prev:hover,
            .cards .slick-next:hover {
              background: #8348D6 !important;
            }
            .cards .slick-prev:before,
            .cards .slick-next:before {
              color: #FFFA00 !important;
            }
            .slick-dots li button:before {
              color: #242D33 !important; 
            }
            .slick-dots li button:hover, .slick-dots li button:focus {
              color: #3D4549 !important;
            }
    `;

    const iframe = document.getElementById(iframeId);
    if (iframe && (iframe as HTMLIFrameElement).contentDocument) {
        const iframeDoc = (iframe as HTMLIFrameElement).contentDocument;
        if (iframeDoc) {
            const styleElement = iframeDoc.createElement('style');
            styleElement.type = 'text/css';
            styleElement.appendChild(iframeDoc.createTextNode(cssStyles));
            iframeDoc.head.appendChild(styleElement);
        }
    } else {
        console.warn('Iframe document is not accessible or not fully loaded.');
    }
};

// Function to change the input placeholder in the chatbot iframe
const changeInputPlaceholder = () => {
    const frameDocument =
        window.frames &&
        (window.frames as any).ymIframe &&
        (window.frames as any).ymIframe.document;
    if (frameDocument) {
        const ymMsgInput = frameDocument.getElementById('ymMsgInput');
        if (ymMsgInput) {
            ymMsgInput.removeAttribute('data-i18n-placeholder');
            ymMsgInput.placeholder = 'Message AI Assistant';
        }
    }
};

// Custom hook to preload the chatbot for the landing page
export const useYellowMessenger = () => {
    useEffect(() => {
        if (!checkIfChatBotEnabled()) return;

        const botId = getChatBotId() ?? 'x1707211238125'; // Static bot ID
        const host = getChatBotHost() ?? 'https://r5.cloud.yellow.ai'; // Static host
        const locale = getLocale();
        const region = getCountry();

        loadYellowMessengerScript(botId, host, locale, region);

        window.addEventListener('message', (data) => {
            const eventData = data && data.data;
            let dataParsed;
            try {
                dataParsed = JSON.parse(eventData);
            } catch (error) {}

            if (dataParsed && dataParsed.event_code === 'create-ui') {
                setTimeout(() => {
                    changeInputPlaceholder();
                    addCustomStylesToIframe('ymIframe');
                }, 0);
            }
        });

        return () => {
            const scriptTag = document.getElementById('yellow_ai_chatbot');
            if (scriptTag) {
                scriptTag.remove();
            }
        };
    }, []);
};

function detectBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('firefox')) {
        applyCustomStylesInFireFox();
    } else {
        applyCustomStylesInOtherBrowser();
    }
}

function applyCustomStylesInFireFox() {
    const iframe = document.getElementById('ymIframe');
    if (iframe) {
        iframe.onload = function () {
            addCustomStylesToIframe('ymIframe');
        };
    }
}

function applyCustomStylesInOtherBrowser() {
    addCustomStylesToIframe('ymIframe');
}
